module.exports = __webpack_public_path__ + "c84d0df9764d3d0cfe6ccc2622e9b6b7.png";